<div class="feedback-text">
    @if (!previewText) {
        <p>{{ feedback.text }}</p>
    } @else {
        @if (isCollapsed) {
            <div>
                <div class="d-inline fa-angle" (click)="isCollapsed = !isCollapsed">
                    <fa-icon [icon]="faAngleRight" />
                    <strong> ({{ 'artemisApp.result.seeMore' | artemisTranslate }}) </strong>
                </div>
                <!-- Only show first line as preview -->
                <p>{{ previewText }} ...</p>
            </div>
        } @else {
            <div>
                <fa-icon class="fa-angle" [icon]="faAngleDown" (click)="isCollapsed = !isCollapsed" />
                <jhi-feedback-text [feedback]="feedback" />
            </div>
        }
    }
</div>
